<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-layout-sider v-model="collapsed" :class="isDeskTop ? 'deskTop' : (noDeskTop ? 'mobile' : 'mobile1')" :trigger="null" collapsible>
      <div class="logo">
        <img class="logoImg" src="@/assets/logo.png">
        <span v-if="!collapsed">Hobolite</span>
      </div>
      <a-menu theme="dark" mode="inline" :default-selected-keys="routerInfo" @click="menuClick">
        <a-menu-item v-if="layMenuList.indexOf(102) !== -1 || layMenuList.indexOf(1021) !== -1 || layMenuList.indexOf(1022) !== -1 || layMenuList.indexOf(1023) !== -1 " key="terminal" class="aMenu">
          <a-icon type="home" />
          <span>终端管理</span>
        </a-menu-item>
        <a-menu-item v-if="layMenuList.indexOf(103) !== -1 || layMenuList.indexOf(1031) !== -1 || layMenuList.indexOf(1032) !== -1 || layMenuList.indexOf(1033) !== -1 || layMenuList.indexOf(1034) !== -1" key="product">
          <a-icon type="appstore" />
          <span>产品管理</span>
        </a-menu-item>
        <a-menu-item v-if="layMenuList.indexOf(104) !== -1 || layMenuList.indexOf(1041) !== -1 || layMenuList.indexOf(1042) !== -1 || layMenuList.indexOf(1043) !== -1 || layMenuList.indexOf(1044) !== -1" key="firmware">
          <a-icon type="setting" />
          <span>固件管理</span>
        </a-menu-item>
        <a-menu-item v-if="layMenuList.indexOf(100) !== -1 || layMenuList.indexOf(1001) !== -1 || layMenuList.indexOf(1002) !== -1 || layMenuList.indexOf(1003) !== -1 || layMenuList.indexOf(1004) !== -1" key="systemAccount">
          <a-icon type="user" />
          <span>系统账号管理</span>
        </a-menu-item>
        <a-menu-item v-if="layMenuList.indexOf(101) !== -1 || layMenuList.indexOf(1001) !== -1 || layMenuList.indexOf(1002) !== -1 || layMenuList.indexOf(1003) !== -1 || layMenuList.indexOf(1004) !== -1" key="role">
          <a-icon type="pie-chart" />
          <span>角色管理</span>
        </a-menu-item>
        <a-menu-item v-if="layMenuList.indexOf(105) !== -1 || layMenuList.indexOf(1051) !== -1 || layMenuList.indexOf(1055) !== -1 " key="userFeedback">
          <a-icon type="mail" />
          <span>用户反馈</span>
        </a-menu-item>
        <a-menu-item v-if="layMenuList.indexOf(106) !== -1 || layMenuList.indexOf(1061) !== -1 || layMenuList.indexOf(1062) !== -1 " key="system">
          <a-icon type="upload" />
          <span>系统设置</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="layout-header" style="line-height: 50px;background: #fff; padding: 0; height: 50px; display:flex;justify-content: space-between;">
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="handCollapsed"
        />
        <a-dropdown style="margin-right: 30px">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <a-icon type="user" :style="{ fontSize: '22px', color: '#000', fontWeight: 600}" /><span style="font-size: 18px;color: #000; margin-left: 5px">{{ userName }}</span>
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <span @click="handLoginOut">退出登录</span>
            </a-menu-item>
            <a-menu-item>
              <span @click="handUpdatePassword">修改密码</span>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </a-layout-header>
      <a-layout-content>
        <router-view />
      </a-layout-content>
    </a-layout>
    <a-config-provider :locale="locale">
      <a-modal
        title="修改密码"
        :visible="passwordVisible"
        :confirm-loading="passwordLoading"
        :width="isDeskTop ? '400px' : '95%'"
        :closable="false"
        :mask-closable="false"
        @ok="handlePassword"
        @cancel="passwordVisible = false"
      >
        <div style="padding: 10px">
          <a-row>
            <a-col :span="24">
              <span>原始密码：</span>
              <a-input v-model="oldPassword" style="width: 75%" placeholder="请输入原始密码" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24" style="margin: 20px 0">
              <span>最新密码：</span>
              <a-input v-model="newPassword" style="width: 75%" placeholder="请输入最新密码" />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <span>确认密码：</span>
              <a-input v-model="confirmPassword" style="width: 75%" placeholder="请输入确认密码" />
            </a-col>
          </a-row>
        </div>
      </a-modal>
    </a-config-provider>
  </a-layout>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { userMenu, updateUserPassword } from '../../api/hobolite'
export default {
  data() {
    return {
      locale: zhCN,
      collapsed: false,
      routerInfo: [],
      layMenuList: [],
      isDeskTop: true,
      noDeskTop: true,
      userName: '',
      passwordVisible: false,
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordLoading: false,
      allRedirect: ''
    }
  },
  watch: {
    $route: {
      handler: function(val, oldval) {
        // this.redirect = route.query && route.query.redirect
        this.allRedirect = val.path
        console.log('111111,路由监听', val.path, oldval)
      },
      immediate: true,
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.userName = this.$cookies.get('userName')
    this.routerInfo.push(this.$route.path.split('/')[1])
    userMenu().then(res => {
      const menuList = []
      res.forEach(record => {
        menuList.push(record.menuId)
      })
      this.layMenuList = menuList
      this.$cookies.set('menuList', JSON.stringify(menuList))
    })
  },
  mounted() {
    this.isDeskTop = !this.$_isMobile()
    // if (isMobile) {
    //   th
    // }
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  methods: {
    handUpdatePassword() {
      this.passwordVisible = true
      this.passwordLoading = false
      this.oldPassword = ''
      this.newPassword = ''
      this.confirmPassword = ''
    },
    handlePassword() {
      if (this.oldPassword.trim() === '' || this.newPassword.trim() === '' || this.confirmPassword.trim() === '') {
        this.$message.info('请先完善信息')
        return
      } else if (this.oldPassword.trim() === this.newPassword.trim()) {
        this.$message.error('原始密码和最新密码一样')
        return
      } else if (this.newPassword.trim() !== this.confirmPassword.trim()) {
        this.$message.error('最新密码和确认密码不一样')
        return
      } else {
        const data = {
          reset: false,
          oldPassword: this.$md5(this.oldPassword),
          password: this.$md5(this.newPassword)
        }
        this.passwordLoading = true
        updateUserPassword(data).then(res => {
          console.log('自动修改密码---------------->', res)

          if (res.isSuccess) {
            console.log('请求失败')
            this.passwordLoading = false
          } else {
            console.log('请求失败1212')
            this.passwordLoading = false
            this.passwordVisible = false
            this.$message.success('密码修改成功，请重新登录')
            this.handLoginOut()
          }
        })
      }
    },
    handCollapsed() {
      if (!this.isDeskTop) {
        this.collapsed = false
        this.noDeskTop = !this.noDeskTop
      } else {
        this.collapsed = !this.collapsed
      }
    },
    menuClick({ key }) {
      // 获取到当前的key,并且跳转
      this.$router.push({
        path: key
      })
      this.noDeskTop = true
    },
    handLoginOut() {
      this.$cookies.remove('token')
      this.$cookies.remove('userName')
      setTimeout(() => {
        this.$router.push({ path: '/login', query: { redirect: this.allRedirect }})
      }, 1000)
    },
    $_isMobile() {
      const { body } = document
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < 992
    },
    // 事件监听------>浏览器窗口大小的变化
    $_resizeHandler() {
      if (!document.hidden) {
        // 判断页面是否隐藏
        this.isDeskTop = !this.$_isMobile()
      }
    }
  }
}
</script>
<style>
#components-layout-demo-custom-trigger{
  height: 100%;
}
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 50px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}
.layout-header{
  box-shadow: 0 1px 4px rgb(0 21 41 / 8%);
  border-bottom: 1px solid #d8dcea;
}
#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 50px;
  background: #00284D;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 20px;
}
.logoImg{
  width: 40px;
  height: 40px;
  margin-right: 15px;
}
.fff{
  height: 100px;
  background-color: lawngreen;
}
#components-layout-demo-custom-trigger .aMenu{
  margin-top: 0 !important
}
.mobile{
  display: none !important;
}
.mobile1{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  transition: width 0.28s;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Layout.vue